var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      [
        _c("h2", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "MAIN_CONTENT.StudentDataForms.formsAwaitingCompletionTitleCase"
              )
            )
          )
        ]),
        _vm._v(" "),
        Object.keys(_vm.message).length > 0
          ? [
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row",
                  staticStyle: { "margin-left": "0", "margin-right": "0" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-xs-12 alert alert-info",
                      class: {
                        "alert-success": _vm.message.TYPE === "success",
                        "alert-danger": _vm.message.TYPE === "error"
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(_vm.message.TEXT) + "\n\t\t\t\t"
                      )
                    ]
                  )
                ]
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.oneTimeForms.length === 0
          ? [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(
                    _vm.$t(
                      "MAIN_CONTENT.StudentDataForms.noFormsAwaitingCompletion"
                    )
                  ) +
                  "\n\t\t"
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-responsive" },
          [
            _vm.oneTimeForms.length > 0
              ? _c(
                  "table-editable-list",
                  {
                    attrs: {
                      columns: _vm.oneTimeColumns,
                      headerClasses: "th-left",
                      "show-select": false,
                      "show-actions": true,
                      actionsHeader: _vm.$t(
                        "MAIN_CONTENT.CourseRequestForms.actions"
                      )
                    }
                  },
                  [
                    _c(
                      "template",
                      { slot: "data-row" },
                      [
                        _vm._l(_vm.oneTimeForms, function(
                          form,
                          studentDataFormsIdx
                        ) {
                          return [
                            _c(
                              "table-list-row",
                              {
                                key: "studentDataForms-" + studentDataFormsIdx,
                                attrs: {
                                  columns: _vm.oneTimeColumns,
                                  rowdata: form,
                                  useAnchor: false,
                                  rowIndex: studentDataFormsIdx
                                }
                              },
                              [
                                _c("template", { slot: "actions" }, [
                                  _c("td", { staticClass: "text-center" }, [
                                    form.FORM_STATUS_FLG === "O"
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-unstyled btn-md",
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteSavedForm(form)
                                              }
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "undo",
                                                "aria-hidden": "true"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.StudentDataForms.resetFormTitleCase"
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.StudentDataForms.resetFormTitleCase"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ],
                              2
                            )
                          ]
                        })
                      ],
                      2
                    )
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c("h2", [
              _vm._v(
                _vm._s(
                  _vm.$t("MAIN_CONTENT.StudentDataForms.onDemandFormsTitleCase")
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "table-editable-list",
              {
                attrs: {
                  columns: _vm.onDemandColumns,
                  headerClasses: "th-left",
                  "show-select": false,
                  "show-actions": false
                }
              },
              [
                _c(
                  "template",
                  { slot: "data-row" },
                  [
                    _vm._l(_vm.onDemandForms, function(
                      form,
                      studentDataFormsIdx
                    ) {
                      return [
                        _c("table-list-row", {
                          key: "studentDataForms-" + studentDataFormsIdx,
                          attrs: {
                            columns: _vm.onDemandColumns,
                            rowdata: form,
                            useAnchor: false,
                            showActions: false,
                            rowIndex: studentDataFormsIdx
                          }
                        })
                      ]
                    })
                  ],
                  2
                )
              ],
              2
            ),
            _vm._v(" "),
            _c("h2", [
              _vm._v(
                _vm._s(
                  _vm.$t("MAIN_CONTENT.StudentDataForms.submittedFormLabel")
                )
              )
            ]),
            _vm._v(" "),
            !!_vm.recentForms.PENDINGFORMS &&
            _vm.recentForms.PENDINGFORMS.length > 0
              ? _c("table", { staticClass: "table table-striped" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", { staticClass: "text-left" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.StudentDataForms.pendingFormLabel"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.StudentDataForms.submittedTitleCase"
                            )
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.recentForms.PENDINGFORMS, function(form, idx) {
                      return _c(
                        "tr",
                        { key: "data_verification_forms_" + idx },
                        [
                          (_vm.role === "student" &&
                            form.STUDENT_ACCESS_FLG === "Y") ||
                          (_vm.role === "parent" &&
                            form.PARENT_ACCESS_FLG === "Y")
                            ? [
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.goToForm(form)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(form.DV_FORM_NAME) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  form.DV_FORM_NAME !== form.DV_FORM_DESC
                                    ? _c("p", { staticClass: "text-muted" }, [
                                        _vm._v(_vm._s(form.DV_FORM_DESC))
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("datetime")(
                                        form.SUBMITTED_DATE,
                                        "MMMM, DD YYYY HH:mm:ss",
                                        "MM/DD/YYYY h:mm a"
                                      )
                                    )
                                  )
                                ])
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("table", { staticClass: "table table-striped" }, [
              _c("thead", [
                _c("tr", [
                  _c(
                    "th",
                    {
                      staticClass: "col-sm-2 text-left",
                      staticStyle: { "white-space": "nowrap" }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.StudentDataForms.recentFormLabel"
                            )
                          ) +
                          "\n\t\t\t\t\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("th", { staticClass: "col-sm-2 text-left" }, [
                    _c("div", { staticClass: "input-group input-group-sm" }, [
                      _c("span", { staticClass: "input-group-addon" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.StudentDataForms.lastTitleCase"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.days,
                            expression: "days"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number", min: "1", max: "200" },
                        domProps: { value: _vm.days },
                        on: {
                          click: function($event) {
                            return _vm.searchTimeOut()
                          },
                          keyup: function($event) {
                            return _vm.searchTimeOut()
                          },
                          change: function($event) {
                            return _vm.searchTimeOut()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.days = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "input-group-addon text-nowrap" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.StudentDataForms.daysTitleCase"
                              )
                            ) + " "
                          ),
                          _vm.loading
                            ? _c("small", { staticClass: "text-nowrap" }, [
                                _c("i", {
                                  staticClass: "fas fa-spinner fa-spin"
                                })
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.StudentDataForms.completedTitleCase"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "text-right" }, [
                    _vm._v(
                      _vm._s(_vm.$t("MAIN_CONTENT.StudentDataForms.status"))
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              !!_vm.recentForms.RECENTLY_COMPLETED_FORMS &&
              _vm.recentForms.RECENTLY_COMPLETED_FORMS.length > 0
                ? _c(
                    "tbody",
                    _vm._l(_vm.recentForms.RECENTLY_COMPLETED_FORMS, function(
                      form,
                      idx
                    ) {
                      return _c(
                        "tr",
                        { key: "data_verification_forms_" + idx },
                        [
                          (_vm.role === "student" &&
                            form.STUDENT_ACCESS_FLG === "Y") ||
                          (_vm.role === "parent" &&
                            form.PARENT_ACCESS_FLG === "Y")
                            ? [
                                _c("td", { attrs: { colspan: "2" } }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.goToForm(form)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(form.DV_FORM_NAME) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  form.DV_FORM_NAME !== form.DV_FORM_DESC
                                    ? _c("p", { staticClass: "text-muted" }, [
                                        _vm._v(_vm._s(form.DV_FORM_DESC))
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("date")(
                                        form.MODIFIED_DATE,
                                        "MMMM, DD YYYY",
                                        "MM/DD/YYYY"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        form.FORM_STATUS_FLG == "A"
                                          ? _vm.$t(
                                              "MAIN_CONTENT.StudentDataForms.approvedTitleCase"
                                            )
                                          : _vm.$t(
                                              "MAIN_CONTENT.StudentDataForms.declinedTitleCase"
                                            )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _c("tbody", [
                    _c("tr", [
                      _c("td", { attrs: { colspan: "4" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.StudentDataForms.resultsMessageText"
                            )
                          )
                        )
                      ])
                    ])
                  ])
            ])
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }